const handleDeleteEquipmentModelsFail = {
  title: 'EL TIPO DE EQUIPO NO PUEDE SER ELIMINADO',
  message: 'No puede ser eliminado. Usado por',
  companies: 'Empresas',
  items: 'Elementos',
  equipmentmodels: 'Tipos de Equipos',
  equipments: 'Equipos',
  inspections: 'Inspecciones',
  itemverifications: 'Elementos de verificación',
  default: 'Colección Genérica'
};

export default handleDeleteEquipmentModelsFail;
